// Utils
import findFirstDomAncestor from './findFirstDomAncestor';
import isDomElementScrollable from './isDomElementScrollable';

const findScrollableDomParent = findFirstDomAncestor(isDomElementScrollable);

export default findScrollableDomParent;
